import React from 'react';
import { Chip } from '@mui/material';
import { useI18n } from '@/hooks/useI18n';

interface MemberStatusChipProps {
  isMember: boolean;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
  color?: 'primary' | 'secondary' | 'success' | 'info';
}

const MemberStatusChip: React.FC<MemberStatusChipProps> = ({ 
  isMember, 
  size = 'small',
  variant = 'outlined',
  color = 'primary'
}) => {
  const { t } = useI18n();
  
  if (!isMember) return null;

  return (
    <Chip
      label={`🏅 ${t('traveller.member')}`}
      size={size}
      variant={variant}
      color={color}
      sx={{
        fontWeight: 500,
        fontSize: '0.75rem'
      }}
    />
  );
};

export default MemberStatusChip;
